import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ICreateAccount } from 'src/app/shared/account/create-account.helper';
import { UpdateAccountPayload } from '../../wizard.types';
import { BaseStepComponent } from '../base-step.component';
import { DataFormComponent } from 'src/app/shared/components/data-form/data-form.component';

@Component({
  selector: 'app-step3',
  templateUrl: './step3.component.html'
})
export class Step3Component extends BaseStepComponent implements AfterViewInit {
  @Input()
  public defaultValues: ICreateAccount;

  @Input()
  public backendValidationErrorsList: string[];

  @Input()
  public isFormDisabled: boolean;

  @Output()
  public updateParentModel: EventEmitter<UpdateAccountPayload> = new EventEmitter<UpdateAccountPayload>();

  @Output()
  public nextStep: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public prevStep: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(DataFormComponent)
  private dataFormComponent: DataFormComponent;


  public isFormValid$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  private dataFormModel: UpdateAccountPayload;

  public ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.dataFormComponent && this.dataFormComponent.form) {
        this.isFormValid$.next(this.dataFormComponent.form.valid);
      }
    }, 0);
  }

  public onFormChanged(obj: any): void {
    this.dataFormModel = { part: obj.val, isFormValid: obj.isFormValid };

    this.isFormValid$.next(this.dataFormModel.isFormValid);
  }

  public onBackClick(): void {
    this.emitCurrentDataFormModel();
    this.prevStep.emit();
  }

  public onCompleteClick(): void {
    this.emitCurrentDataFormModel();
    this.nextStep.emit();
  }

  private emitCurrentDataFormModel(): void {
    if (this.dataFormModel) {
      this.updateParentModel.emit(this.dataFormModel);
    }
  }
}
